export const getTasmanBayData = () => ({
  name: "Tasman Bay",
  region: "Nelson",
  country: "Nouvelle-Zélande",
  description: "Tasman Bay est une sous-région viticole côtière de Nelson, connue pour ses vignobles établis et ses vins élégants. Les sols calcaires et les microclimats variés favorisent la diversité des styles.",
  type: "subregion",
  area: "200 ha",
  production: "0.01 million hectolitres",
  climate: "Climat tempéré avec influences maritimes, étés chauds et hivers doux",
  soil: "Sols calcaires, bonne rétention d'eau, diversité géologique",
  characteristics: {
    climate: "Climat tempéré avec influences maritimes, étés chauds et hivers doux",
    soil: "Sols calcaires, bonne rétention d'eau, diversité géologique",
    viticulture: "Viticulture traditionnelle, rendements contrôlés, diversité de cépages"
  },
  wineStyles: {
    white: "Chardonnay élégant, Sauvignon Blanc aromatique, Gewürztraminer floral",
    red: "Pinot Noir fruité, tanins souples",
    rosé: "Rosés légers et fruités"
  },
  history: "Tasman Bay est l'une des plus anciennes zones viticoles de Nelson, avec une tradition de production de vins de qualité depuis les années 1990.",
  foodPairing: "Poissons, fruits de mer, fromages frais, plats d'été",
  grapeVarieties: [
    { name: "Chardonnay", percentage: "35%", description: "Vins élégants, notes de fruits blancs" },
    { name: "Sauvignon Blanc", percentage: "25%", description: "Vins aromatiques, acidité vive" },
    { name: "Pinot Noir", percentage: "20%", description: "Vins rouges fruités, tanins souples" },
    { name: "Gewürztraminer", percentage: "10%", description: "Vins blancs floraux, aromatiques" },
    { name: "Autres", percentage: "10%", description: "Pinot Gris, expérimentaux" }
  ],
  statistics: {
    totalArea: "200 ha",
    production: "0.01 million hectolitres",
    wineries: "4+ domaines",
    exportPercentage: "15%"
  },
  viticulture: "La viticulture à Tasman Bay privilégie la diversité des cépages et la qualité. Les rendements sont modérés pour préserver la fraîcheur et l'aromatique.",
  winemaking: "La vinification se fait en cuves inox pour les blancs et en fûts pour les rouges. Les styles varient selon les producteurs.",
  terroir: "Tasman Bay est caractérisée par ses sols calcaires et ses microclimats variés, permettant une grande diversité de styles et de cépages.",
  mapAreas: [
    { region: "Tasman Bay", x: 172.8, y: -41.2, color: "#8a4a8a", size: 2 }
  ]
}); 